import * as React from 'react';

import styled from 'styled-components';

import { BREAK_POINTS } from '../../consts/styleDedupe';
import { COLOURS } from '../../consts/style';

const Banner = styled.div`
  display: flex;
  width: 100%;
  z-index: 0;
  background-color: ${COLOURS.GREY.GREY_4};
  min-height: 396px;

  @media screen and (min-width: ${BREAK_POINTS.Min.SM}) {
    min-height: 328px;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    min-height: 360px;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    min-height: 404px;
  }
`;

export const BannerLoading = () => {
  return <Banner data-id="banner--loading" />;
};
